export const isToday = ({ startTime }: { startTime: number }) => {
  const date = new Date(startTime * 1000);
  const itemDate = date.getDate();
  const itemMonth = date.getMonth();
  const itemYear = date.getFullYear();
  const today = new Date();
  const month = today.getMonth();
  const year = today.getFullYear();

  return itemYear === year && itemMonth === month && itemDate === today.getDate();
};
